import React from 'react';
import { Table, Link, Icon } from '@b-design/fusion';
import $i18n from '@/i18n';

import './index.less';

interface TableProps {
  dataSource: any[];
  style?: React.CSSProperties;
}

const ArchivedTable: React.FC<TableProps> = ({ dataSource, style }) => {
  const actions = () => {
    return (
      <div className="actions-content">
        <Link
          style={{
            padding: '0 5px',
            fontSize: '12px',
            color: 'var(--superapp-primary-1)',
            letterSpacing: '0.4px',
            lineHeight: '20px',
          }}
          // onClick={() => changeRouter(record)}
        >
          <Icon type="idea--outline" size="xs" />
          {$i18n.get({ id: 'aopf.pages.miniapp.table.Action.Activate', dm: '激活' })}
        </Link>
      </div>
    );
  };

  const renderTitle = (_v, _i, record) => {
    return (
      <div style={{ display: 'flex' }}>
        <img src={record.url} className="common-table-app-icon" alt="" />
        <a className="common-table-app-name" style={{ lineHeight: '24px' }}>{record.title}</a>
      </div>
    );
  };

  const renderId = (value) => {
    return <div className="common-table-app-id">{value}</div>;
  };

  return (
    <div className="miniapp-list-archived-table">
      <Table style={style} dataSource={dataSource}>
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Miniapp', dm: '应用名称' })}
          dataIndex="title"
          cell={renderTitle}
          width={150}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.ID', dm: 'ID' })}
          dataIndex="id"
          width={180}
          cell={renderId}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Archived.On', dm: '归档' })}
          dataIndex="modified"
          width={190}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Action', dm: '操作' })}
          cell={actions}
          width={160}
        />
      </Table>
    </div>
  );
};

export default ArchivedTable;
